<template>
  <SwitchRoot
    :id="props.id ?? settingId"
    v-model="modelValue"
    :disabled="props.disabled"
    :aria-label="props.label"
    :class="{
      'flex h-5 w-9 shrink-0 items-center overflow-hidden rounded-full border border-border bg-card outline-2 outline-offset-2 outline-blue-500 transition-colors duration-200 ease-in-out hover:bg-muted focus-visible:outline disabled:cursor-not-allowed': true,
      '!bg-blue-500': modelValue,
    }"
  >
    <SwitchThumb
      class="m-1 ml-[0.1875rem] size-3 rounded-full bg-white shadow transition duration-200 ease-in-out data-[state=checked]:translate-x-4"
    />
  </SwitchRoot>
</template>

<script setup lang="ts">
import { SwitchRoot, SwitchThumb } from "reka-ui";

import { useSettingControl } from "@/components/Setting/context";

const modelValue = defineModel<boolean>({ default: false });

const props = defineProps<{
  label: string;
  disabled?: boolean;
  id?: string;
}>();

const setting = useSettingControl();
const settingId = setting?.register();
</script>
